module.exports = __webpack_public_path__ + "dist/img/analysis.5a6fac87.jpg";